import { render, staticRenderFns } from "./EpisodeTime.vue?vue&type=template&id=252479bf&"
import script from "./EpisodeTime.vue?vue&type=script&lang=js&"
export * from "./EpisodeTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports